export interface NewsArticleDto {
  ArticleId: number;
  ShortDescr: string;
  LongDescr: string;
  ArticleDate: Date;
  ArticleType: string;
  StartDate: Date;
  EndDate: Date;
  DateCreated: Date;
  DateChanged: Date;
  Headline: boolean;
}

export function initializedNewsArticleDto(): NewsArticleDto {
  return {
    ShortDescr: '',
    LongDescr: '',
    ArticleType: null,
    ArticleDate: new Date(),
    StartDate: new Date(),
    EndDate: new Date(),
  } as NewsArticleDto;
}
